<script setup lang="ts">
import { defineAsyncComponent } from 'vue';
import { appState } from '../game/logic';
import { router } from '../router';
const PixiApp = defineAsyncComponent(() => import('../components/PixiApp.vue'));
const uxState = appState.uxState;
console.log('Game component, ux state:', uxState);

if(!uxState.isAuthenticated){
   router.push({ path: '/login' });
}
</script>

<template>
   <PixiApp />
</template>

<style>
#pixiApp {
   position: absolute;
   left: 0;
   top: 0;
   width: 100vw;
   height: 100vh;
   margin: 0;
}
</style>